/**
 * Máscara de moeda progressiva (BRL) para inputs de texto.
 *
 * O valor é acumulado a partir dos dígitos digitados, preenchendo sempre a
 * partir dos centavos e "empurrando" para a esquerda conforme o usuário digita:
 *
 *   "1"        -> "0,01"
 *   "10"       -> "0,10"
 *   "100"      -> "1,00"
 *   "1000"     -> "10,00"
 *   "10000"    -> "100,00"
 *   "100000"   -> "1.000,00"
 *   "1000000"  -> "10.000,00"
 *   "10000000" -> "100.000,00"
 *
 * Aceita qualquer string (inclusive já mascarada) e reformata sempre a partir
 * dos dígitos, o que torna o backspace previsível.
 */
export function maskCurrencyInput(raw: string): string {
  const digits = (raw ?? '').replace(/\D/g, '');
  if (!digits) return '';
  // Remove zeros à esquerda mantendo ao menos 1 dígito (evita "007").
  const normalized = digits.replace(/^0+(?=\d)/, '');
  const cents = Number(normalized);
  return (
    new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      style: 'currency',
      currency: 'BRL'
    })
      .format(cents / 100)
      // Remove o símbolo "R$ " deixando apenas "1.234,56" (o label já indica R$).
      .replace(/\s*R\$\s*/, '')
      .trim()
  );
}

/**
 * Converte uma string mascarada ("1.234,56") no número correspondente (1234.56).
 * Retorna 0 quando não há dígitos.
 */
export function parseCurrencyToNumber(masked: string): number {
  const digits = (masked ?? '').replace(/\D/g, '');
  if (!digits) return 0;
  return Number(digits) / 100;
}
